<template>
	<div class="discussion">
		<h1>Title discussion</h1>
	</div>
</template>

<script>
// import PlanningService from '@/services/PlanningService'
export default {
	components: {
	},
	props: {
	},
	data () {
		return {
		}
	},
	methods: {
	},
	computed: {
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_discussion.scss";
</style>
